<script lang="ts">
  import { formatLength } from '$lib/core/model';
  import { SNAP_LABELS } from '$lib/core/snap';
  import type { EditorState } from '../editor-state.svelte';

  const { editor }: { editor: EditorState } = $props();

  const coordinates = $derived(
    editor.cursor
      ? `${formatLength(editor.cursor.x, editor.lengths)}, ${formatLength(editor.cursor.y, editor.lengths)}`
      : '—',
  );
</script>

<footer>
  <span class="hint">{editor.toolHint}</span>
  <span class="spacer"></span>
  {#if editor.statusMessage}
    <span class="message">{editor.statusMessage}</span>
  {/if}
  {#if editor.activeSnap}
    <span class="snap">{SNAP_LABELS[editor.activeSnap.kind]}</span>
  {/if}
  {#if editor.snapSettings.ortho}
    <span class="snap">Ortho</span>
  {/if}
  <span class="coords">{coordinates}</span>
  <span class="zoom">{Math.round(editor.viewport.zoom * 100)}%</span>
</footer>

<style>
  footer {
    /* Fixed height: a taller status bar would shrink the canvas and shift the drawing. */
    box-sizing: border-box;
    height: 2.25rem;
    display: flex;
    align-items: center;
    gap: var(--space-3);
    padding: 0 var(--space-3);
    overflow: hidden;
    border-top: 1px solid var(--color-border);
    background: var(--color-surface);
    font-size: 0.75rem;
    color: var(--color-text-muted);
  }

  .spacer {
    flex: 1;
  }

  .snap,
  .coords,
  .zoom {
    font-variant-numeric: tabular-nums;
    color: var(--color-text);
  }

  .snap {
    line-height: 1.2;
    white-space: nowrap;
    padding: 1px 6px;
    border-radius: 999px;
    background: var(--color-bg);
    border: 1px solid var(--color-border);
  }

  .message {
    color: var(--color-accent);
  }
</style>
